import dayjs from 'dayjs'
import store from '@/store'

export function _formatTime(time) {
  if (!time) return ''
  const [hour, min] = time.split(':')
  let mark = ''
  if (parseInt(hour) >= 12) {
    mark = 'pm'
    const _hour = String(parseInt(hour) - 12).padStart(1, '0')
    return `${_hour}:${min}${mark}`
  } else {
    const _hour = String(parseInt(hour)).padStart(1, '0')
    mark = 'am'
    return `${_hour}:${min}${mark}`
  }
}

export function _formatWeek(week) {
  const weekShorNameList = {
    monday: 'Mon',
    tuesday: 'Tue',
    wednesday: 'Wed',
    thursday: 'Thu',
    friday: 'Fri',
    saturday: 'Sat',
    sunday: 'Sun'
  }
  return weekShorNameList[week]
}

/**
 * Determine whether it is the size of the mobile phone terminal
 * @param WIDTH {Number} Maximum size of mobile phone
 * @return {Boolean} Is it the size of the mobile phone
 */
/**
 * 判断是否是手机端的尺寸
 * @param WIDTH {Number} 手机端最大尺寸
 * @return {Boolean} 是否是手机端尺寸
 */
export function widthOfDeviceIsMobile(WIDTH = 640) {
  const {
    body
  } = document
  // Get the collection of body self position and size
  // 获取 body 自身位置和尺寸的合集
  const rect = body.getBoundingClientRect()
  return rect.width - 1 < WIDTH
}

// Page scrolls to the top position
// 页面滚动到顶部位置
export function scrollTop() {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
}

// Get the parameters after the url
// 获取 url 后面的参数
export function getUrlParam(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)') // Construct a regular expression object with target parameters   // 构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg) // Match target parameters   // 匹配目标参数
  if (r != null) return unescape(r[2]); return null // Return parameter value   // 返回参数值
}

/**
 * Get the business hours that meet the current time
 * @param {Object} operatingHours Business hours information
 * @param {String} time Time compared with business hours
 * @returns {Object, undefined} If business hours are met, return the corresponding business hours; If the business is not satisfied, return undefined
 */
/**
 * 获取满足当前时间的营业时间
 * @param {Object} operatingHours 营业时间信息
 * @param {String} time 和营业时间比对的时间
 * @returns {Object, undefined} 若满足营业，返回对应营业时间；若不满足营业，返回 undefined
 */
export function _getNowOperatingHours(operatingHours, time) {
  const fakeHeader = '2020-10-9:'
  let nowTime
  if (!time) { // If there is no time parameter transfer, it will be compared with the current time   // 若没有 time 传参，就和当前时间比对
    const hour = parseInt(dayjs(store.state.app.currentVenueTime).format('HH'))
    const minute = parseInt(dayjs(store.state.app.currentVenueTime).format('mm'))
    nowTime = fakeHeader + `${hour}:${minute}`
  } else {
    nowTime = fakeHeader + time
  }

  if (operatingHours?.hourSettings?.length) { // New data structure, multi time period   // 新数据结构，多时间段
    const result = operatingHours.hourSettings.find(item => {
      const fromHour = fakeHeader + item.fromHour.trim()
      const toHour = fakeHeader + item.toHour.trim()
      return _isOperatingHours(fromHour, toHour, nowTime)
    })
    return result
  } else { // Compatible with old data structures, with only one time period   // 兼容旧数据结构，只有一个时间段
    const todayOperatingHours = {
      fromHour: operatingHours.fromHour,
      toHour: operatingHours.toHour
    }
    const fromHour = fakeHeader + operatingHours.fromHour.trim()
    const toHour = fakeHeader + operatingHours.toHour.trim()
    return _isOperatingHours(fromHour, toHour, nowTime) ? todayOperatingHours : undefined
  }
}

/**
 * Judge whether the current time meets the business hours
 * @param {String} fromHour Business Hours, Start Period
 * @param {String} toHour Business Hours, End Period
 * @param {String} nowTime Comparison time
 * @returns {Boolean} Whether the comparison time meets the business hours
 */
/**
 * 判断当前时间是否满足营业时间段
 * @param {String} fromHour 营业时间，开始时段
 * @param {String} toHour 营业时间，结束时段
 * @param {String} nowTime 对比时间
 * @returns {Boolean} 对比时间是否满足营业时间段
 */
function _isOperatingHours(fromHour, toHour, nowTime) {
  // fixed Safari Date.parse bug
  const parseFromHour = Date.parse(dayjs(fromHour))
  const parseToHour = Date.parse(dayjs(toHour))
  const parseNowTime = Date.parse(dayjs(nowTime))
  return parseNowTime >= parseFromHour && parseToHour >= parseNowTime
}

/**
 * Whether to pass the customized business hours
 * @param operatingHours {Object} Set custom business hours
 * @param week {String} week
 * @param hour {String} hour
 * @param minute {String} minute
 * @returns {Boolean} Whether to pass the customized business hours
 */
/**
 * 是否通过自定义的营业时间
 * @param operatingHours {Object} 设置的自定义营业时间
 * @param week {String} 周
 * @param hour {String} 小时
 * @param minute {String} 分钟
 * @returns {Boolean} 是否通过自定义的营业时间
 */
export function _isPassCustomHours(operatingHours, week, hour, minute) {
  let pass = false
  const customHours = operatingHours.customHours
  if (customHours) {
    // Get the corresponding business hours according to the day of the week
    // 根据周几，获取对应的营业时间信息
    const timeInfo = customHours[week]
    // Whether it is open on the current day, and whether the time passed meets the business hours
    // 当天是否营业，传来的时间是否满足营业时间段
    if (timeInfo?.enable && _getNowOperatingHours(timeInfo, `${hour}:${minute}`)) pass = true
  }
  return pass
}

/**
 * 判断营业时间是否“没有配置”。后端可能把空营业时间返回成 []、{} 或空值，
 * 这种情况下应当跟随餐厅营业时间，而不是当成“已关闭”把分类/商品隐藏。
 * @param {*} operatingHours 营业时间数据
 * @returns {Boolean} 是否为“没有配置”
 */
export function _isEmptyOperatingHours(operatingHours) {
  if (operatingHours == null) return true
  if (Array.isArray(operatingHours)) return operatingHours.length === 0
  if (typeof operatingHours === 'object') return Object.keys(operatingHours).length === 0
  return !operatingHours
}

/**
 * Current time, open or not
 * @param {Object} operatingHours Business hours information
 * @param {String} type Business Hours Type
 * @param {Boolean} venueIsOpenTime Whether the restaurant is open
 * @returns {Boolean} Whether it is open at the current time
 */
/**
 * 当前时间，是否营业
 * @param {Object} operatingHours 营业时间信息
 * @param {String} type 营业时间类型
 * @param {Boolean} venueIsOpenTime 餐厅是否营业
 * @returns {Boolean} 当前时间，是否营业
 */
export function _isOpenStatus(operatingHours, type = '', venueIsOpenTime = true) {
  if (!venueIsOpenTime) return true
  // 没有配置营业时间时（后端可能返回 [] / {} / 空值），跟随餐厅营业时间，
  // 避免分类/商品被误判为“已关闭”导致整个菜单为空、弹出“暂停在线点单”。
  if (_isEmptyOperatingHours(operatingHours)) return venueIsOpenTime

  let res = false
  if (operatingHours?.type === type) {
    if (venueIsOpenTime) res = true
  } else {
    // custom operation hours
    const deliveryInfo = store.state?.contactDetails?.deliveryInfo[store.state.venueId] ?? {}
    let week, hour, minute
    if (store.state.app.isOnline && deliveryInfo.preOrderTimeSettings) {
      // If it is a delivery system advanced order, it should be compared according to the scheduled time and business hours
      // 若是外卖系统预定单，要根据预定时间和营业时间进行比对
      week = dayjs(deliveryInfo.preOrderTimeSettings).format('dddd').toLowerCase()
      hour = Number(dayjs(deliveryInfo.preOrderTimeSettings).format('H'))
      minute = Number(dayjs(deliveryInfo.preOrderTimeSettings).format('m'))
    } else {
      // Compare according to the current time and business hours
      // 根据当前时间和营业时间进行比对
      week = dayjs.tz().format('dddd').toLowerCase()
      hour = parseInt(dayjs.tz().format('HH'))
      minute = parseInt(dayjs.tz().format('mm'))
    }
    res = _isPassCustomHours(operatingHours, week, hour, minute)
  }
  return res
}

/**
 * Find the business hours that match the current time, or find the business hours that are closest to the current time
 * @param {Object} weeklyOperatingHours The business hours set for the restaurant you want to find
 * @param {Boolean} isNextDay Whether to start searching the next day's business hours
 * @param {Number} index The program will be terminated after searching for several times
 * @param {Boolean} isToday Whether the data searched must be today
 * @returns {String} Time period to meet business hours
 */
/**
 * 查找符合当前时间的营业时间段,或者找出最接近当前时间的营业时间段
 * @param {Object} weeklyOperatingHours 要查找的餐厅设置的营业时间
 * @param {Boolean} isNextDay 是否开始下一天营业时间的查找
 * @param {Number} index 查找了几次,如果查找了 7 次,程序就要终止
 * @param {Boolean} isToday 查找的数据是否一定要在今天
 * @returns {String} 满足营业时间的时间段
 */
export function _weeklyOperatingHours(weeklyOperatingHours, isNextDay = false, index = 0, isToday = false) {
  if (index >= 7) return 'business hours not found' // If it is not found until the 7th time, then don't find it anymore   // 如果找到第 7 次还没找到那就不找了
  const weekOrderList = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday'
  ]
  // Current day of the week
  // 当前星期几
  const todayWeek = dayjs(store.state.app.currentVenueTime).format('dddd').toLowerCase()
  // Index of the date of the next cycle
  // 下一次循环日期的索引
  const todayWeekNextIndex = (weekOrderList.indexOf(todayWeek) + index >= 6) ? 0 : weekOrderList.indexOf(todayWeek) + index
  // Get the current timestamp
  // 获取当前时间戳
  const todayTime = dayjs('2019-01-25 ' + dayjs(store.state.app.currentVenueTime).format('HH:mm')).unix()
  // Set the business hours according to the specific venues returned at the current time
  // 根据当前时间返回的具体餐厅设置营业时间段
  const hourSettingsData = weeklyOperatingHours[weekOrderList[todayWeekNextIndex]]
  const businessHours = _businessHours(hourSettingsData, todayTime, isNextDay)

  if (businessHours?.res || businessHours?.item?.fromHour) {
    // If the business hours are at the current time, the empty string will be assigned. If not, the specific day of the week will be assigned
    // 如果营业时间在当前时间就赋值空字符串,不在就赋值具体周几
    businessHours.week = weekOrderList[todayWeekNextIndex] === todayWeek ? '' : _formatWeek(weekOrderList[todayWeekNextIndex])
    // Return to the current business time period during the current business hours, and return to the time period closest to the current time when not in the current business hours
    // 在当前营业时间就返回当前营业时间段,不在就返回距离当前时间最接近的时间段
    return businessHours.res ? businessHours.res : businessHours.week + ' ' + businessHours.item.fromHour + ' - ' + businessHours.item.toHour
  } else {
    // If it is not found today and isToday = true, an empty string will be returned directly
    // 若今天没有找到，并且 isToday = true，直接返回空字符串
    if (isToday) return ''
    // If you don't find it today, go to the next day and keep looking for it for a week
    // 今天没有找到就去下一天找, 一直找一周
    return _weeklyOperatingHours(weeklyOperatingHours, true, 1 + index, isToday)
  }
}

/**
 * Find the business hours that match the current time, or find the business hours that are closest to the current time
 * @param {Array} data To find the restaurant business hours data matching the current time
 * @param {Number} todayTime Current timestamp
 * @param {Boolean} isNextDay Whether to open the search for the next day
 * @returns {Object} The closestTime matches the business hours of the current time
 */
/**
 * 查找符合当前时间的营业时间段,或者找出最接近当前时间的营业时间段
 * @param {Array} data 要查找符合当前时间的餐厅营业时间数据
 * @param {Number} todayTime 当前时间戳
 * @param {Boolean} isNextDay 是否开启查找下一天
 * @returns {Object} closestTime 符合当前时间的营业时间段
 */
function _businessHours(data, todayTime, isNextDay = false) {
  let closestTime = { // Business hours closest to the current time   // 最接近当前时间的营业时间
    // The minimum time difference from the current time
    // 距离当前时间最小的时间差
    minTime: 99999999999,
    // This is not assigned during the current business hours
    // 不在当前营业时间赋值这个
    item: {},
    // If the value is assigned during business hours and the time of the day
    // 如果在营业时间并且是当天的时间赋值
    res: false,
  }
  // If the business hours are not opened, return to the original closestTime
  // 如果营业时间没有开启返回原始 closestTime
  if (!data.enable) {
    return closestTime
  }
  data.hourSettings.forEach(item => {
    // Start of business timestamp
    // 开始营业时间戳
    const fromHour = dayjs('2019-01-25 ' + item.fromHour).unix()
    // End of business timestamp
    // 结束营业时间戳
    const toHour = dayjs('2019-01-25 ' + item.toHour).unix()
    // The earliest timestamp of the day
    // 一天中最早的时间戳
    const today = dayjs('2019-01-25 00:00').unix()
    // Select the nearest business hour of the day
    // 选取最接近当天现在的营业时间
    if ((fromHour - todayTime > 0) && (fromHour - todayTime < closestTime.minTime) && !isNextDay) {
      closestTime = {
        ...closestTime,
        minTime: fromHour - todayTime,
        item: {
          ...item,
          fromHour: dayjs(`2020-10-10 ${item.fromHour}`).format('hh:mma'),
          toHour: dayjs(`2020-10-10 ${item.toHour}`).format('hh:mma')
        }
      }
    }
    // Select the earliest business hour of the next day
    // 选取下一天最早的营业时间
    if ((fromHour - today < closestTime.minTime) && isNextDay) {
      closestTime = {
        ...closestTime,
        minTime: fromHour - todayTime,
        item: {
          ...item,
          fromHour: dayjs(`2020-10-10 ${item.fromHour}`).format('hh:mma'),
          toHour: dayjs(`2020-10-10 ${item.toHour}`).format('hh:mma')
        }
      }
    }
    // If res is assigned during business hours and the time of the day
    // 如果在营业时间并且是当天的时间赋值 res
    if (todayTime >= fromHour && todayTime <= toHour && !isNextDay) {
      closestTime.res = dayjs(`2020-10-10 ${item.fromHour}`).format('hh:mma') + ' - ' + dayjs(`2020-10-10 ${item.toHour}`).format('hh:mma')
    }
  })

  // If the business segment time of the next day is not obtained, the nearest and earlier business hours of the next day will be obtained
  // 如果没有获取到下一天的营业分段时间, 那就获取距离下一天最近的，早一些的营业时间
  if ((!closestTime.item.fromHour && !closestTime.res) && isNextDay) {
    closestTime = {
      item: {
        fromHour: dayjs(`2020-10-10 ${data.fromHour}`).format('hh:mma'),
        toHour: dayjs(`2020-10-10 ${data.toHour}`).format('hh:mma')
      }
    }
  }

  return closestTime
}

/**
 * decodeURI that never throws
 * vue-router has already decoded route params once, so a value containing a
 * stray '%' (e.g. a table named "100%") makes decodeURI throw URIError.
 * Falls back to the original value.
 * 不会抛异常的 decodeURI
 * vue-router 已对路由参数解码过一次,值里含单独 '%'(如桌号 "100%")时
 * decodeURI 会抛 URIError,此时退回原始值。
 */
export function safeDecodeURI(val) {
  try {
    return decodeURI(val)
  } catch (e) {
    return val
  }
}
